import React from "react";

export const Clients = (props) => {
  return (
    <div id="clients">
      <div className="container">
        <div className="section-title text-center">
          <h2>our Partners</h2>
        </div>
        <div className="row">
          {props.data
            ? props.data.map((d, i) => (
                <div key={`${d.name}-${i}`} className="col-md-3 text-center">
                  <div className="testimonial">
                      <img src={d.img} alt="" />{" "}
                  </div>
                </div>
              ))
            : "loading"}
        </div>
      </div>
    </div>
  );
};
